import createPersistedState from 'vuex-persist-indexeddb';

const DEFAULT_DEBOUNCE_MS = 400;

function parseDebounceMs() {
  const raw = process.env.VUE_APP_VUEX_PERSIST_DEBOUNCE_MS;
  if (raw == null || raw === '') {
    return DEFAULT_DEBOUNCE_MS;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : DEFAULT_DEBOUNCE_MS;
}

/**
 * vuex-persist-indexeddb — mutation마다 IndexedDB 쓰기 대신 디바운스로 묶는다.
 * 부팅 중 연속 commit(setProjects, isAuthTokenExpired 등) 시 메인 스레드·I/O 부하를 줄인다.
 *
 * VUE_APP_VUEX_PERSIST_DEBOUNCE_MS=0 이면 디바운스 없이 기본 플러그인과 동일.
 */
export default function createDebouncedPersistedState(options = {}) {
  const debounceMs = parseDebounceMs();
  if (debounceMs === 0) {
    return createPersistedState(options);
  }

  return createPersistedState({
    ...options,
    subscriber(store) {
      return (handler) => {
        let timer = null;
        let latestMutation = null;
        let latestState = null;
        let writeChain = Promise.resolve();

        const flush = () => {
          if (timer != null) {
            clearTimeout(timer);
            timer = null;
          }
          const mutation = latestMutation;
          const state = latestState;
          if (!mutation || state == null) {
            return writeChain;
          }
          writeChain = writeChain
            .then(() => handler(mutation, state))
            .catch((err) => {
              console.warn('[vuex-persist] debounced write failed:', err);
            });
          return writeChain;
        };

        const schedule = () => {
          if (timer != null) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            timer = null;
            flush();
          }, debounceMs);
        };

        if (typeof window !== 'undefined') {
          window.addEventListener('pagehide', () => {
            flush();
          });
        }

        return store.subscribe((mutation, state) => {
          latestMutation = mutation;
          latestState = state;
          schedule();
        });
      };
    }
  });
}
